<template lang="pug">
#heatmap_summary
  table.table
    tbody
      tr
        th 計測PV数
        td {{ event_count }}
      tr
        th 平均滞在時間
        td {{ avg_staying_sec }} 秒
      tr
        th ファーストビュー離脱率
        td {{ Number(fv_withdraw_rate).toFixed(1) }} %
      tr
        th 最終到達率
        td {{ final_arrival_rate }} %

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: {
    state_name: {
      type: String,
      required: true,
      default: "heatmap"
    },
  },
  data() {
    return {
    }
  },
  computed: {
    event_count() {
      return this.$store.state[this.state_name].event_count;
    },
    fv_withdraw_rate() {
      return this.$store.state[this.state_name].fv_withdraw_rate;
    },
    final_arrival_rate(){
      return this.$store.state[this.state_name].final_arrival_rate;
    },
    avg_staying_sec(){
      return this.$store.state[this.state_name].avg_staying_sec;
    }
  }
}
</script>
